/* ============================================================
   AVORA HOME — Shared Carousel Logic
   Scroll-snap track, arrow navigation, scroll position indicator
   ============================================================ */

(function() {

  function initCarousel(section) {
    var track = section.querySelector('.avora-carousel__track');
    var prevBtn = section.querySelector('.avora-carousel__arrow--prev');
    var nextBtn = section.querySelector('.avora-carousel__arrow--next');
    var fill = section.querySelector('.avora-carousel__indicator-fill');

    if (!track) return;

    var firstCard = track.querySelector('.avora-card');
    if (!firstCard) return;

    /* Calculate scroll amount: 2 cards at a time */
    function getScrollAmount() {
      var card = track.querySelector('.avora-card');
      if (!card) return 300;
      return (card.offsetWidth + 16) * 2;
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });
    }

    /* Update scroll position indicator */
    if (fill) {
      function updateIndicator() {
        var maxScroll = track.scrollWidth - track.clientWidth;
        if (maxScroll <= 0) {
          fill.style.left = '0%';
          return;
        }
        var pct = track.scrollLeft / maxScroll;
        var fillWidth = 30; /* percent of bar */
        fill.style.left = (pct * (100 - fillWidth)) + '%';
      }

      track.addEventListener('scroll', updateIndicator, { passive: true });
      updateIndicator();

      /* Recalculate on resize.
         No cleanup needed — carousels persist for the page lifetime
         and the debounced handler is lightweight. */
      var resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(updateIndicator, 150);
      });
    }

    /* Update arrow visibility based on scroll position */
    function updateArrows() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (prevBtn) {
        prevBtn.style.opacity = track.scrollLeft <= 5 ? '0.3' : '1';
        prevBtn.style.pointerEvents = track.scrollLeft <= 5 ? 'none' : 'auto';
      }
      if (nextBtn) {
        nextBtn.style.opacity = track.scrollLeft >= maxScroll - 5 ? '0.3' : '1';
        nextBtn.style.pointerEvents = track.scrollLeft >= maxScroll - 5 ? 'none' : 'auto';
      }
    }

    track.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
  }

  function initAll() {
    document.querySelectorAll('.avora-carousel').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Re-init on Shopify editor section load */
  document.addEventListener('shopify:section:load', function(e) {
    var section = e.target;
    if (section.querySelector('.avora-carousel')) {
      initCarousel(section);
    }
  });

})();
